<template>
	<div style="height: 100%; padding-bottom: 10px">
		<MagazzinoArticoliGiacenzaCodiciComponent :component="true" :tableHideColumn="tableHideColumn"
			ref="cmpMagazzinoArticoliListComponent"></MagazzinoArticoliGiacenzaCodiciComponent>
	</div>
</template>

<script>
import MagazzinoArticoliGiacenzaCodiciComponent from "./MagazzinoArticoliGiacenzaCodiciComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
	mixins: [UtilityMixin],
	components: { MagazzinoArticoliGiacenzaCodiciComponent },
	data() {
		return {
			rows: 0,
			perPage: 50,
			currentPage: 1,
			pathResource: "/contabilitasoggettotipi",
			showModalLoading: false,
			listKey: 0,
			filtroMagazzinoArticoliCodici: {},
			items: [],
			tableHideColumn: ["codiceArticolo", "codiceAzienda", "categoria", "nome", "nomeArticolo", "actions"],
			fields: [
				{
					label: "*",
					key: "index",
					thStyle: "width: 1rem",
				},
				{
					label: "Matricola/Lotto Codice",
					key: "lottoMatricola",
					thStyle: "width: 5rem",
				},
				{
					label: "Codice Articolo",
					key: "codiceArticolo",
					thStyle: "width: 5rem",
				},
				{
					label: "Descrizione Articolo",
					key: "descrizioneArticolo",
					thStyle: "width: 5rem",
				},
				{
					label: "Codice Azienda",
					key: "codiceAzienda",
					thStyle: "width: 1rem",
				},
				{ class: "sa-table-column-action-double", key: "actions", label: "" },
			],
		};
	},
	mounted() { },
	watch: {
		currentPage() {
			let me = this;
			me.loadData();
		},
	},
	methods: {
		init(idArticolo) {
			this.$refs.cmpMagazzinoArticoliListComponent.loadDataArticoli({ idArticolo: idArticolo });
		},
		loadData() {
			let me = this;
			me.openShowModalLoading();
			me.$emit("beforeLoadData");
			if (sessionStorage["filtroMagazzinoArticoliCodici"]) {
				me.filtroMagazzinoArticoliCodici = JSON.parse(sessionStorage["filtroMagazzinoArticoliCodici"]);
			}
			me.filtroMagazzinoArticoliCodici.page = me.currentPage;
			me.filtroMagazzinoArticoliCodici.forPage = me.perPage;
			UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroMagazzinoArticoliCodici, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			let me = this;
			me.items = response.data.data.list;
			me.rows = response.data.data.recordsNumber;
			me.closeShowModalLoading();
			me.$emit("afterLoadData");
		},
		loadDataError(error) {
			let me = this;
			console.error("Errore durante il caricamento dei dati:", error);
			me.items = [];
			me.rows = 0;
			me.closeShowModalLoading();
			me.$emit("afterLoadData");
		},
	},
};
</script>

<style scoped></style>
